/* eslint-disable react/button-has-type */
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from 'reactstrap';

import SweetAlert from 'react-bootstrap-sweetalert';
import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';

import {
  deleteRangeRestriction,
  getRangeRestrictionList,
} from '../../../../app/store/actions/rangeRestriction';
import ROUTES from '../../../../config/routes';

class RangeRestrictionList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalDelete: false,
      rangeRestrictionDelete: null,
    };

    this.defaultSorted = [
      {
        id: 'code',
        desc: false,
      },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button className="btn btn-default btn-xs">
              {I18n.t('BEE55' /* Ações */)}
            </button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                <DropdownItem onClick={() => this.showRangeRestrictionDetail(rows.row)}>
                  {I18n.t('BEE56' /* Detalhes */)}
                </DropdownItem>
                <DropdownItem onClick={() => this.showEditRangeRestriction(rows.row)}>
                  {I18n.t('BEE57' /* Editar */)}
                </DropdownItem>
                <DropdownItem onClick={() => this.showCopyRangeRestriction(rows.row)}>
                  {I18n.t('BEE80' /* Copiar */)}
                </DropdownItem>
                <DropdownItem onClick={() => this.showDeleteRangeRestriction(rows.row)}>
                  {I18n.t('BEE81' /* Eliminar */)}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE145' /* Filial */),
        accessor: 'branchCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
      }, {
        Header: I18n.t('BEE2668' /* Família Material */),
        accessor: 'materialFamilyName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE83' /* Nome */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      }, {
        Header: I18n.t('BEE135' /* Observação */),
        accessor: 'note',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
      },
    ];
  }

  componentDidMount() {
    this.getRangeRestriction();
    this.setInitState();
  }

  setInitState = () => {
    this.setState({
      showModalDelete: false,
      rangeRestrictionDelete: null,
    });
  };

  getRangeRestriction = async () => {
    try {
      await this.props.getRangeRestrictionList();
    } catch (e) {
      addNotification(
        'danger',
        I18n.t('BEE1627' /* Erro */),
        I18n.t('BEE1969' /* Erro ao buscar dados */),
        'top-right',
      );
    }
  };

  showRangeRestrictionDetail = (rangeRestriction) => {
    this.props.history.push({
      pathname: ROUTES.RANGE_RESTRICTION_DETAIL,
      state: {
        rangeRestriction: rangeRestriction._original,
      },
    });
  };

  showEditRangeRestriction = (rangeRestriction) => {
    this.props.history.push({
      pathname: ROUTES.RANGE_RESTRICTION_EDIT,
      state: {
        rangeRestriction: rangeRestriction._original,
      },
    });
  };

  showCopyRangeRestriction = (rangeRestriction) => {
    this.props.history.push({
      pathname: ROUTES.RANGE_RESTRICTION_COPY,
      state: {
        rangeRestriction: rangeRestriction._original,
      },
    });
  };

  deleteRangeRestriction = async (rangeRestriction) => {
    try {
      await this.props.deleteRangeRestriction(rangeRestriction._original.id);
      await this.setInitState();

      addNotification(
        'success',
        I18n.t('BEE4514' /* Remover Restrição de Range */),
        I18n.t('BEE4515' /* Restrição de Range eliminada com sucesso! */),
        'top-right',
      );
      await this.getRangeRestriction();
    } catch (err) {
      await this.setInitState();
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE4514' /* Remover Restrição de Range */),
            `${error.code} - ${error.message || error.details}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE4514' /* Remover Restrição de Range */),
            I18n.t('BEE4538', { 0: rangeRestriction._original.name } /* Erro ao eliminar a Restrição de Range %{0}! */),
            'top-right',
          );
        }
      }
    }
  };

  showDeleteRangeRestriction = (rangeRestriction) => {
    this.setState({ showModalDelete: true, rangeRestrictionDelete: rangeRestriction });
  };

  render() {
    const { rangeRestrictionList = [] } = this.props;
    const { rangeRestrictionDelete, showModalDelete } = this.state;

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE4500' /* Restrição de Range */)}</li>
          </ol>
        </div>
        <Table
          downloadCSV
          wikiHelp={ROUTES.RANGE_RESTRICTION_HELP}
          headerTitle={I18n.t('BEE4500' /* Restrição de Range */)}
          actionButtons={(
            <div className="ml-auto">
              <Link to={ROUTES.RANGE_RESTRICTION_CREATE} className="btn btn-success btn-sm btn-rounded pl-2 pr-3">
                <i className="fa fa-plus mr-1" />
                {' '}
                {I18n.t('BEE4501' /* Incluir restrição de Range */)}
              </Link>
            </div>
          )}
          panelHeaderProps={{
            onClickReload: this.getRangeRestriction,
          }}
          filterable
          data={rangeRestrictionList}
          columns={this.tableColumns}
          expander
          defaultPageSize={10}
          defaultSorted={this.defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
        />
        {(showModalDelete
          && (
            <SweetAlert
              danger
              showCancel
              cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
              confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="default"
              title={I18n.t('BEE101' /* Você tem certeza? */)}
              onConfirm={() => this.deleteRangeRestriction(rangeRestrictionDelete)}
              onCancel={() => this.setInitState()}
            >
              {I18n.t('BEE4539', { 0: rangeRestrictionDelete.name } /* A Restrição de Range %{0} será eliminada! */)}
            </SweetAlert>
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  rangeRestrictionList: state.rangeRestriction && state.rangeRestriction.rangeRestrictionList,
});

const mapDispatchToProps = (dispatch) => ({
  getRangeRestrictionList: () => dispatch(getRangeRestrictionList()),
  deleteRangeRestriction: (rangeRestrictionId) => dispatch(deleteRangeRestriction(rangeRestrictionId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RangeRestrictionList));
